import React from 'react';

import PerfectScrollbar from 'react-perfect-scrollbar';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CmtVertical from '../../../../../@coremat/CmtNavigation/Vertical';
import IntlMessages from '../../../../utils/IntlMessages';
import {
  DateRange,
  NewReleases,
  BarChart,
  PostAdd,
  Schedule,
  FormatListBulleted,
  EventAvailable,
  AccountBalanceWallet,
  FreeBreakfast,
  LocalAtm,
  Policy,
  EventSeatRounded,
  Money,
  AddBox,
  CreditCard,
  Receipt,
  DoneAll,
  Work,
  ArrowDownward,
  ArrowUpward,
  PersonAdd,
  PieChart,
  AssignmentTurnedIn,
  ShoppingCart,
  Settings,
  LocalOffer,
  Cast,
  Room,
  Mail,
  EventSeat,
  History,
  Category,
  Euro,
  Dashboard,
  AttachMoney,
  Loyalty,
  ImportExport,
} from '@material-ui/icons';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import BusinessIcon from '@material-ui/icons/Business';
import PeopleIcon from '@material-ui/icons/People';
import ReceiptIcon from '@material-ui/icons/Receipt';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import CalendarViewDay from '@material-ui/icons/CalendarViewDay';

import { useSelector } from 'react-redux';
import HotelIcon from '@material-ui/icons/Hotel';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import CancelIcon from '@material-ui/icons/Cancel';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import AssignmentIcon from '@material-ui/icons/Assignment';
import HomeIcon from '@material-ui/icons/Home';
import SvgIcon from '@material-ui/core/SvgIcon';

import { ReactComponent as DashboardIcon } from '../../../../../icons/dashboard.svg';
import { ReactComponent as CockpitIcon } from '../../../../../icons/cockpit.svg';
import { ReactComponent as BookingIcon } from '../../../../../icons/booking.svg';
import { ReactComponent as NewReservationIcon } from '../../../../../icons/new reservation.svg';
import { ReactComponent as PreBookingsIcon } from '../../../../../icons/pre bookings.svg';
import { ReactComponent as InvoicesIcon } from '../../../../../icons/invoices.svg';
import { ReactComponent as LoyaltyIcon } from '../../../../../icons/loyalty manager.svg';
import { ReactComponent as RMIcon } from '../../../../../icons/revenue management.svg';
import { ReactComponent as AnalyticsIcon } from '../../../../../icons/analytics.svg';
import { ReactComponent as ArrivalsIcon } from '../../../../../icons/arrivals.svg';
import { ReactComponent as PropertiesIcon } from '../../../../../icons/properties.svg';
import { ReactComponent as TimelineIcon } from '../../../../../icons/timeline.svg';
import { ReactComponent as GuestBookIcon } from '../../../../../icons/guest book.svg';
import { ReactComponent as DeparturesIcon } from '../../../../../icons/departures.svg';
import { ReactComponent as CashRegisterIcon } from '../../../../../icons/cash register.svg';

import { ReactComponent as LogoutIcon } from '../../../../../icons/logout.svg';
import { ReactComponent as ExtrasIcon } from '../../../../../icons/extras.svg';
import { ReactComponent as SelkCheckinIcon } from '../../../../../icons/self check in.svg';
import { ReactComponent as ConfigurationIcon } from '../../../../../icons/configuration.svg';
import { ReactComponent as CustomPolicyIcon } from '../../../../../icons/custom policy.svg';
import { ReactComponent as PackageIcon } from '../../../../../icons/package.svg';
import { ReactComponent as RatePlanIcon } from '../../../../../icons/rate plan.svg';
import { ReactComponent as UsersIcon } from '../../../../../icons/users.svg';
import { ReactComponent as MealPlanIcon } from '../../../../../icons/meal.svg';
import { ReactComponent as ChargesIcon } from '../../../../../icons/chargers.svg';
import { ReactComponent as PaymentGatewaysIcon } from '../../../../../icons/payment gateways.svg';
import { ReactComponent as CouponIcon } from '../../../../../icons/coupon.svg';
import { ReactComponent as CurrenciesIcon } from '../../../../../icons/currencies.svg';
import { ReactComponent as TaxesIcon } from '../../../../../icons/taxes.svg';
import { ReactComponent as PromotionsIcon } from '../../../../../icons/promotions.svg';

import { ReactComponent as StayIcon } from '../../../../../icons/in hotel.svg';
import { ReactComponent as ChannelManagerIcon } from '../../../../../icons/integrations.svg';
import { ReactComponent as PropertiesRoomsIcon } from '../../../../../icons/propertiesrooms.svg';

import { ReactComponent as TasksIcon } from '../../../../../icons/tasks.svg';
import { ReactComponent as ReviewIcon } from '../../../../../icons/review.svg';
import { ReactComponent as VCIcon } from '../../../../../icons/vc.svg';
import { ReactComponent as MessageIcon } from '../../../../../icons/message.svg';

import { ReactComponent as ActivityLog } from '../../../../../icons/activitylog.svg';
import { ReactComponent as AiChat } from '../../../../../icons/aichat.svg';
import { ReactComponent as Inqueries } from '../../../../../icons/inquires.svg';
import { ReactComponent as TravelAgencies } from '../../../../../icons/travelagencies.svg';

const useStyles = makeStyles(() => ({
  menuIcon: {
    fill: '#a5a5a5',
    height: '14px',
    width: '14px',
    '& path': { fill: 'unset' },
  },

  perfectScrollbarSidebar: {
    height: '100%',
    transition: 'all 0.3s ease',
    '.Cmt-sidebar-fixed &, .Cmt-Drawer-container &': {
      //  height: 'calc(100% - 167px)',
    },
    '.Cmt-modernLayout &': {
      //  height: 'calc(100% - 72px)',
    },
    '.Cmt-miniLayout &': {
      //  height: 'calc(100% - 91px)',
    },
    '.Cmt-miniLayout .Cmt-sidebar-content:hover &': {
      //    height: 'calc(100% - 167px)',
    },
  },
}));

const SideBar = () => {
  const classes = useStyles();
  const navigationMenus = [];
  const { authUser } = useSelector(({ auth }) => auth);
  var userRole = -1,
    isSubAccount = 1,
    bookingengine = 0,
    vcenabled = 0,
    taskenabled = 0,
    rmenabled = 0,
    expired = 0,
    features = 0,
    modules = 0;
  var cloudUser = 0;
  var engine = 0;
  if (authUser != null) userRole = authUser.role;
  if (authUser != null) bookingengine = authUser.bookingengine;
  if (authUser != null) vcenabled = authUser.vcenabled;
  if (authUser != null) rmenabled = authUser.rmenabled;
  if (authUser != null) taskenabled = authUser.apptasks;
  if (authUser != null) cloudUser = authUser.clouduser;
  if (authUser != null) expired = authUser.expired;
  if (authUser != null) features = authUser.features;
  if (authUser != null) modules = authUser.modules;
  if (authUser != null && authUser.hotels != null && authUser.hotels.length > 0) engine = authUser.hotels[0].engine;
  if (authUser != null && authUser.isSubAccount != null) isSubAccount = authUser.isSubAccount;

  if (cloudUser == 0 && expired == 1)
    navigationMenus.push({
      name: <IntlMessages id={'pages.orderNow'} />,
      type: 'item',
      icon: <ShoppingCart />,
      link: '/pages/upgrade',
    });

  if (cloudUser == 1 && (features & 1) != 0)
    navigationMenus.push({
      name: <IntlMessages id={'pages.cockpit'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <DashboardIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/cockpit',
    });
  if ([10, 11, 16, 17, 12, 20].includes(userRole) && cloudUser == 0)
    navigationMenus.push({
      name: <IntlMessages id={'pages.cockpit3'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <DashboardIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/dashboard',
    });
  if ([10, 11, 16, 17, 12].includes(userRole) && cloudUser == 0)
    navigationMenus.push({
      name: <IntlMessages id={'pages.cockpit2'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <CockpitIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/cockpit-wbp',
    });

  if ((cloudUser == 1 && (features & 2) != 0) || (cloudUser == 0 && [10, 11, 16, 17, 12].includes(userRole)))
    navigationMenus.push({
      name: <IntlMessages id={'pages.timeline'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <TimelineIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/timeline',
    });

  if (cloudUser == 1 && (features & 2) != 0 /* || (cloudUser==0 && [10].includes(userRole))*/)
    navigationMenus.push({
      name: <IntlMessages id={'pages.calendar'} />,
      type: 'item',
      icon: <CalendarViewDay />,
      link: '/pages/calendar',
    });

  if (cloudUser == 1 && (features & 2) != 0)
    navigationMenus.push({
      name: <IntlMessages id={'pages.quickReservation'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <NewReservationIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/quickreservation',
    });

  if (cloudUser == 0 && [10, 11, 16, 17, 12, 20].includes(userRole))
    navigationMenus.push({
      name: <IntlMessages id={'pages.quickReservation2'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <NewReservationIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/quickreservation',
    });

  if (cloudUser == 0 && [10, 11, 16, 17, 12, 13, 20].includes(userRole)) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.bookings'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <BookingIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/bookings',
    });
  }

  if (cloudUser == 0 && [10, 11, 16, 17, 12, 13, 20].includes(userRole)) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.offers'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <PreBookingsIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/offers',
    });
  }

  if (cloudUser == 0 && [10, 11, 16, 17, 12, 13, 20].includes(userRole)) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.inquires'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <Inqueries className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/inquires',
    });
  }

  if (cloudUser == 0 && [10, 11, 16, 17, 12, 13].includes(userRole)) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.chat'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <AiChat className={classes.menuIcon} />
        </SvgIcon>
      ),

      link: '/pages/chat',
    });
  }

  if (cloudUser == 0 && [10, 11, 16, 17, 12, 13].includes(userRole)) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.messages'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <MessageIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/messages',
    });
  }

  if (cloudUser == 0 && [10, 11, 16, 17, 12, 13].includes(userRole)) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.reviews'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <ReviewIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/reviews',
    });
  }
  if (cloudUser == 0 && [10].includes(userRole)) {
    if (expired == 1) link = '/pages/upgrade';
    else link = '/pages/yield';
    navigationMenus.push({
      name: 'Yield Manager',
      type: 'item',
      icon: <ImportExport />,
      link: link,
    });
  }

  if (cloudUser == 0 && [10].includes(userRole) && rmenabled == 1) {
    if (expired == 1) link = '/pages/upgrade';
    else link = '/pages/revenue/cockpit';
    navigationMenus.push({
      name: 'Revenue Manager',
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <RMIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: link,
    });
    if (expired == 1) link = '/pages/upgrade';
    else link = '/pages/loyalty';
    navigationMenus.push({
      name: 'Loyalty Manager',
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <LoyaltyIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: link,
    });
  }

  if (cloudUser == 1 && (features & 2) != 0) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.bookings'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <BookingIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/bookingsm',
    });
  }

  if ([10, 12].includes(userRole) && cloudUser == 0) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.invoices'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <InvoicesIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/invoices',
    });
  }
  if ([10, 12].includes(userRole) && cloudUser == 0) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.cashRegister'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <CashRegisterIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/cash-register',
    });
  }

  if ([10, 11].includes(userRole) && cloudUser == 0) {
    navigationMenus.push({
      name: engine == 0 ? <IntlMessages id={'pages.guestBook'} /> : <IntlMessages id={'pages.guestBook2'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <GuestBookIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/guests',
    });
  }

  if ([10].includes(userRole) && cloudUser == 0) {
    var link = '/pages/statisticsm';
    if (expired == 1) link = '/pages/upgrade';
    navigationMenus.push({
      name: <IntlMessages id={'pages.statistics'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <AnalyticsIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: link,
    });
  }

  if ((cloudUser == 1 && (modules & 2) != 0 && (features & 4) != 0) || (cloudUser == 0 && [5].includes(userRole))) {
    var link = '/pages/hkrooms';
    navigationMenus.push({
      name: <IntlMessages id={'pages.hkrooms'} />,
      type: 'item',
      icon: <Work />,
      link: link,
    });
  }

  if (bookingengine == 1 || (cloudUser == 1 && (features & 2) != 0) || (cloudUser == 1 && (features & 4) != 0)) {
    if ([5, 10, 11, 12].includes(userRole))
      navigationMenus.push({
        name: <IntlMessages id={'pages.arrivals'} />,
        type: 'item',
        icon: (
          <SvgIcon viewBox="-5 -5 24 24">
            <ArrivalsIcon className={classes.menuIcon} />
          </SvgIcon>
        ),
        link: '/pages/arrivals',
      });
    if ([5, 10, 11, 12].includes(userRole))
      navigationMenus.push({
        name: <IntlMessages id={'pages.stay'} />,
        type: 'item',
        icon: (
          <SvgIcon viewBox="-5 -5 24 24">
            <StayIcon className={classes.menuIcon} />
          </SvgIcon>
        ),
        link: '/pages/stay',
      });

    if ([5, 10, 11, 12].includes(userRole))
      navigationMenus.push({
        name: <IntlMessages id={'pages.departures'} />,
        type: 'item',
        icon: (
          <SvgIcon viewBox="-5 -5 24 24">
            <DeparturesIcon className={classes.menuIcon} />
          </SvgIcon>
        ),
        link: '/pages/departures',
      });
  }

  if (taskenabled == 1) {
    var link = '/admin/mod_tasks';
    if (expired == 1) link = '/pages/upgrade';

    navigationMenus.push({
      name: 'Tasks',
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <TasksIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: link,
    });
  }
  if (vcenabled == 1) {
    var link = '/admin/mod_vc';
    if (expired == 1) link = '/pages/upgrade';
    navigationMenus.push({
      name: <IntlMessages id="application.virtualConcierge" />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <VCIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: link,
    });
  }
  if (cloudUser == 1) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.logout'} />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <LogoutIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/pages/logout',
    });
  }

  if (cloudUser == 1 && (modules & 4) != 0 && (features & 4) == 0) {
    var link = '/pages/statisticsm';
    if (expired == 1) link = '/pages/upgrade';
    navigationMenus.push({
      name: <IntlMessages id="pages.statistics" />,
      type: 'section',
      children: [
        {
          name: <IntlMessages id="pages.reports" />,
          type: 'item',
          icon: (
            <SvgIcon viewBox="-5 -5 24 24">
              <AnalyticsIcon className={classes.menuIcon} />
            </SvgIcon>
          ),
          link: link,
        },
      ],
    });
  }

  /*if (cloudUser == 1 && (modules & 8) != 0 && (features & 4) == 0) {
    navigationMenus.push({
      name: <IntlMessages id="pages.selfCheckIn2" />,
      type: 'section',
      children: [
        {
          name: <IntlMessages id="pages.selfCheckInEmail2" />,
          type: 'item',
          icon: <PersonAdd />,
          link: '/pages/selfcisend',
        },
        {
          name: <IntlMessages id="pages.selfCheckInConfig" />,
          type: 'item',
          icon: <Settings />,
          link: '/pages/selfciconfig',
        },
      ],
    });
  }*/
  if (cloudUser == 0 && [10, 14].includes(userRole)) {
    navigationMenus.push({
      name: <IntlMessages id="pages.hotelsAndRooms" />,
      type: 'item',
      icon: (
        <SvgIcon viewBox="-5 -5 24 24">
          <PropertiesRoomsIcon className={classes.menuIcon} />
        </SvgIcon>
      ),
      link: '/admin/hotels_info',
    });
  }
  if (cloudUser == 0 && [20].includes(userRole) && isSubAccount == 0) {
    navigationMenus.push({
      name: <IntlMessages id="pages.accounts" />,
      type: 'section',
      children: [
        {
          name: <IntlMessages id="pages.customers" />,
          type: 'item',
          icon: (
            <SvgIcon viewBox="-5 -5 24 24">
              <UsersIcon className={classes.menuIcon} />
            </SvgIcon>
          ),
          link: '/pages/travelagents',
        },
      ],
    });
  }
  if (cloudUser == 0 && [10].includes(userRole)) {
    var link = '/pages/upgrade';
    if (expired == 1) {
      navigationMenus.push({
        name: <IntlMessages id="pages.channelManager" />,
        type: 'item',
        icon: (
          <SvgIcon viewBox="-5 -5 24 24">
            <ChannelManagerIcon className={classes.menuIcon} />
          </SvgIcon>
        ),
        link: link,
      });

      navigationMenus.push(
        {
          name: <IntlMessages id="pages.accounts" />,
          type: 'section',
          children: [
            {
              name: <IntlMessages id="pages.customers" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <UsersIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
            {
              name: <IntlMessages id="pages.travelAgencies" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <TravelAgencies className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
            {
              name: <IntlMessages id="activityLog" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <ActivityLog className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
          ],
        },
        {
          name: <IntlMessages id={'pages.promotions'} />,
          type: 'section',
          children: [
            {
              name: <IntlMessages id={'pages.promotionsDiscounts'} />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <PromotionsIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
            {
              name: <IntlMessages id="pages.coupons" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <CouponIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
          ],
        },
        {
          name: <IntlMessages id="pages.properties" />,
          type: 'section',
          children: [
            {
              name: <IntlMessages id="pages.mealPlans" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <MealPlanIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },

            {
              name: <IntlMessages id="pages.ratePlans" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <RatePlanIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
            {
              name: <IntlMessages id="pages.policies" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <CustomPolicyIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
            {
              name: <IntlMessages id="pages.packages" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <PackageIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
            {
              name: <IntlMessages id="pages.extras" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <ExtrasIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
            {
              name: <IntlMessages id="pages.taxes" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <TaxesIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
            {
              name: <IntlMessages id="pages.currencies" />,
              type: 'item',
              icon: <Money />,
              link: link,
            },
            {
              name: <IntlMessages id="pages.paymentGateways" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <PaymentGatewaysIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: link,
            },
          ],
        },
      );
    }

    if (expired == 0) {
      navigationMenus.push({
        name: <IntlMessages id="pages.channelManager" />,
        type: 'item',
        icon: (
          <SvgIcon viewBox="-5 -5 24 24">
            <ChannelManagerIcon className={classes.menuIcon} />
          </SvgIcon>
        ),
        link: '/admin/mod_channel_manager_hotels',
      });

      navigationMenus.push({
        name: <IntlMessages id="pages.selfCheckIn2" />,
        type: 'section',
        children: [
          {
            name: <IntlMessages id="pages.selfCheckInEmail2" />,
            type: 'item',
            icon: (
              <SvgIcon viewBox="-5 -5 24 24">
                <SelkCheckinIcon className={classes.menuIcon} />
              </SvgIcon>
            ),
            link: '/pages/selfcisend',
          },
          {
            name: <IntlMessages id="pages.selfCheckInConfig" />,
            type: 'item',
            icon: (
              <SvgIcon viewBox="-5 -5 24 24">
                <ConfigurationIcon className={classes.menuIcon} />
              </SvgIcon>
            ),
            link: '/pages/crm',
          },
        ],
      });
      navigationMenus.push(
        {
          name: <IntlMessages id="pages.accounts" />,
          type: 'section',
          children: [
            {
              name: <IntlMessages id="pages.customers" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <UsersIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/hotel_owners_management',
            },
            {
              name: <IntlMessages id="pages.travelAgencies" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <TravelAgencies className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_customers_agencies',
            },
            {
              name: <IntlMessages id="activityLog" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <ActivityLog className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/pages/activitylog',
            },
          ],
        },
        {
          name: <IntlMessages id={'pages.promotions'} />,
          type: 'section',
          children: [
            {
              name: <IntlMessages id={'pages.promotionsDiscounts'} />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <PromotionsIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_campaigns',
            },
            {
              name: <IntlMessages id={'pages.charges'} />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <ChargesIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_charges',
            },

            {
              name: <IntlMessages id="pages.coupons" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <CouponIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_coupons',
            },
          ],
        },
        {
          name: <IntlMessages id="pages.properties" />,
          type: 'section',
          children: [
            {
              name: <IntlMessages id="pages.mealPlans" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <MealPlanIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_meal_plans',
            },
            {
              name: <IntlMessages id="pages.ratePlans" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <RatePlanIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_pricelists',
            },
            {
              name: <IntlMessages id="pages.policies" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <CustomPolicyIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_policies',
            },

            {
              name: <IntlMessages id="pages.packages" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <PackageIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_packages',
            },
            {
              name: <IntlMessages id="pages.extras" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <ExtrasIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_extras',
            },
            {
              name: <IntlMessages id="pages.taxes" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <TaxesIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_taxes',
            },
            {
              name: <IntlMessages id="pages.currencies" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <CurrenciesIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_currencies',
            },

            {
              name: <IntlMessages id="pages.paymentGateways" />,
              type: 'item',
              icon: (
                <SvgIcon viewBox="-5 -5 24 24">
                  <PaymentGatewaysIcon className={classes.menuIcon} />
                </SvgIcon>
              ),
              link: '/admin/mod_booking_hotel_payment_gateways',
            },
          ],
        },
      );
    }
  }

  if (cloudUser == 2 && (features & 8) != 0)
    if (cloudUser == 2 && (features & 8) != 0) {
      /*    navigationMenus.push({
      name: <IntlMessages id={'pages.gastroHomePage'} />,
      type: 'item',
      icon: <BarChart />,
      link: '/gastro/homepage',
    });*/

      navigationMenus.push({
        name: <IntlMessages id={'pages.gastroRevenue'} />,
        type: 'item',
        icon: <PieChart />,
        link: '/gastro/revenue',
      });
      navigationMenus.push({
        name: <IntlMessages id={'pages.gastroTables'} />,
        type: 'item',
        icon: <EventSeat />,
        link: '/gastro/tables',
      });
      navigationMenus.push({
        name: <IntlMessages id={'pages.gastroInvoices'} />,
        type: 'item',
        icon: <ReceiptIcon />,
        link: '/gastro/invoices',
      });
      navigationMenus.push({
        name: <IntlMessages id={'pages.gastroOrders'} />,
        type: 'item',
        icon: <CancelIcon />,
        link: '/gastro/orders',
      });
      navigationMenus.push({
        name: <IntlMessages id={'pages.gastroLog'} />,
        type: 'item',
        icon: <History />,
        link: '/gastro/log',
      });
    }
  if (cloudUser == 2 && (features & 16) != 0) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.gastroAnalytics'} />,
      type: 'item',
      icon: <BarChart />,
      link: '/gastro/analytics',
    });
    if (authUser != null) var POS = authUser.POS;
    if (POS.length > 0 && (POS[0].Cloud == null || POS[0].Cloud === 0))
      navigationMenus.push({
        name: <IntlMessages id={'pages.gastroWH'} />,
        type: 'item',
        icon: <Category />,
        link: '/gastro/wh',
      });
  }
  if (cloudUser == 2) {
    if (authUser != null) var POS = authUser.POS;
    var x = localStorage.getItem('idPos');
    if (x != null && x != undefined && POS.filter(item => item.PosId == x).length > 0) {
      navigationMenus.push({
        name: <IntlMessages id={'gastro.Home'} />,
        type: 'item',
        icon: <HomeIcon />,
        link: '/gastro/reset',
      });
    }
  }
  if (cloudUser == 2) {
    navigationMenus.push({
      name: <IntlMessages id={'pages.logout'} />,
      type: 'item',
      icon: <ExitToAppIcon />,
      link: '/gastro/logout',
    });
  }

  /*if ([10].includes(userRole))
    navigationMenus.push({
      name: 'Bookings',
      type: 'item',
      icon: <FormatListBulleted />,
      link: '/pages/bookings',
    });*/

  return (
    <PerfectScrollbar className={classes.perfectScrollbarSidebar}>
      <CmtVertical menuItems={navigationMenus} />
    </PerfectScrollbar>
  );
};

export default SideBar;
